import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Label,
  Icon,
  FormGroup,
  FormField,
  Dropdown,
  Input
} from 'semantic-ui-react'

const CardDrugTransferRequestUX = (props: any) => {
    return(
      <div
        id="CardDrugTransferRequestUX-div-0"
        style={{padding: "10px"}}>
        <div
          id="CardDrugTransferRequestUX-div-88"
          style={{display: "flex", justifyContent: "space-between"}}>
          
          <div
            id="CardDrugTransferRequestUX-div-97"
            style={{display: "flex", alignItems: "center"}}>
            
            <div
              className="ui label violet ribbon"
              id="CardDrugTransferRequestUX-div-99"
              style={{display: props.showStatus ? "" : "none"}}>
              {props.code}
            </div>
            <div
              id="CardDrugTransferRequestUX-div-100"
              style={{fontWeight: "bold", fontSize: "1.2rem"}}>
              {props.languageUX === "en" ? "Request medicine from other pharmacies" : "ขอยาจากห้องยาอื่นๆ"}
            </div>
          </div>
          <div
            id="CardDrugTransferRequestUX-div-98"
            style={{display: "flex"}}>
            
            <Label
              color={props.status ? "red" : ""}
              id="CardDrugTransferRequestUX-Label-101"
              style={{display: props.showStatus ? "" : "none"}}>
              {props.status}
            </Label>
            <div
              id="CardDrugTransferRequestUX-div-102"
              style={{cursor: "pointer", margin: "3px -5px 0 15px", display: props.closeIcon ? "" : "none"}}>
              
              <Icon
                className="red large"
                id="CardDrugTransferRequestUX-Icon-103"
                name={"close"}
                onClick={props.onClose}>
              </Icon>
            </div>
          </div>
        </div>
        <div
          className="ui divider"
          id="CardDrugTransferRequestUX-div-91"
          style={{margin: "0.5rem 0",  display: props.showStatus ? "" : "none"}}>
          
        </div>
        <div
          id="CardDrugTransferRequestUX-div-80">
          {props.ErrorMessage}
        </div>
        <div
          className="ui form"
          id="CardDrugTransferRequestUX-div-104">
          
          <FormGroup
            id="CardDrugTransferRequestUX-FormGroup-105"
            inline={true}>
            <FormField
              id="CardDrugTransferRequestUX-FormField-106"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-116"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Request department by" : "หน่วยงานที่ขอ"}
              </div>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-107"
              inline={true}>
              <Label
                id="CardDrugTransferRequestUX-Label-117"
                style={{minWidth: "max-content"}}>
                {props.requesterName || "\u00a0-"}
              </Label>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-108"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-118"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Dispensing department by" : "หน่วยงานจ่าย"}
              </div>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-109"
              inline={true}
              width={3}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardDrugTransferRequestUX-Dropdown-119"
                onChange={props.onChangeValue("selectedDivisionPharma")}
                options={props.divisionPharmaOptions}
                selection={true}
                style={{width: "100%"}}
                value={props.selectedDivisionPharma}>
              </Dropdown>
            </FormField>
            <div
              id="CardDrugTransferRequestUX-div-153"
              style={{"margin":"0px 1rem 0px 0.25rem","width":"10px","height":"10px","borderRadius":"50%","backgroundColor":"#b3b0b0", display: props.notAllowedAdd ? "none" : ""}}>
              
            </div>
            <FormField
              className={props.notAllowedAdd ? "hidden" : ""}
              id="CardDrugTransferRequestUX-FormField-110"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-120"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Select drug" : "เลือกยา"}
              </div>
            </FormField>
            <FormField
              className={props.notAllowedAdd ? "hidden" : ""}
              id="CardDrugTransferRequestUX-FormField-111"
              inline={true}
              width={3}>
              <div
                id="CardDrugTransferRequestUX-div-121"
                style={{width: "100%"}}>
                {props.drugSearch}
              </div>
            </FormField>
            <FormField
              className={props.notAllowedAdd ? "hidden" : ""}
              id="CardDrugTransferRequestUX-FormField-112"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-122"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Quantity" : "จำนวน"}
              </div>
            </FormField>
            <FormField
              className={props.notAllowedAdd ? "hidden" : ""}
              id="CardDrugTransferRequestUX-FormField-113"
              inline={true}
              width={2}>
              <Input
                fluid={true}
                id="CardDrugTransferRequestUX-Input-123"
                onChange={props.onChangeValue("selectedDrugDose")}
                style={{width: "100%"}}
                type="number"
                value={props.selectedDrugDose || ""}>
              </Input>
            </FormField>
            <FormField
              className={props.notAllowedAdd ? "hidden" : ""}
              id="CardDrugTransferRequestUX-FormField-114"
              inline={true}>
              <Button
                color="green"
                id="CardDrugTransferRequestUX-Button-124"
                onClick={props.onAddDrug}
                size="tiny">
                {props.languageUX === "en" ? "ADD" : "เพิ่ม"}
              </Button>
            </FormField>
            <FormField
              className={props.notAllowedAdd ? "hidden" : ""}
              id="CardDrugTransferRequestUX-FormField-151"
              inline={true}>
              <Button
                color="yellow"
                id="CardDrugTransferRequestUX-Button-152"
                onClick={props.onClear}
                size="tiny">
                {props.languageUX === "en" ? "Clear" : "เคลียร์"}
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            className={props.requested?.id ? "":"hidden"}
            id="CardDrugTransferRequestUX-FormGroup-125"
            inline={true}>
            <FormField
              id="CardDrugTransferRequestUX-FormField-126"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-132"
                style={{width: "50px"}}>
                {props.languageUX === "en" ? "Requester" : "ผู้ขอ"}
              </div>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-127"
              inline={true}>
              <Input
                id="CardDrugTransferRequestUX-Input-133"
                readOnly={true}
                value={props.requested?.name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-128"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-134">
                {props.languageUX === "en" ? "time" : "เวลา"}
              </div>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-129"
              inline={true}>
              <Input
                id="CardDrugTransferRequestUX-Input-135"
                readOnly={true}
                value={props.requestedDate || ""}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            className={!props.canceled  ? "hidden":""}
            id="CardDrugTransferRequestUX-FormGroup-138"
            inline={true}>
            <FormField
              id="CardDrugTransferRequestUX-FormField-139"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-145"
                style={{width: "50px"}}>
                {props.languageUX === "en" ? "Canceller" : "ผู้ยกเลิก"}
              </div>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-140"
              inline={true}>
              <Input
                id="CardDrugTransferRequestUX-Input-150"
                readOnly={true}
                value={props.canceled?.name || ""}>
              </Input>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-141"
              inline={true}>
              <div
                id="CardDrugTransferRequestUX-div-146">
                {props.languageUX === "en" ? "time" : "เวลา"}
              </div>
            </FormField>
            <FormField
              id="CardDrugTransferRequestUX-FormField-142"
              inline={true}>
              <Input
                id="CardDrugTransferRequestUX-Input-149"
                readOnly={true}
                value={props.canceledDate || ""}>
              </Input>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardDrugTransferRequestUX-div-3">
          
          <Table
            data={props.drugTransferRequestlist}
            getTrProps={props.drugRowProps}
            headers={`ลำดับ,รหัสยา,ชื่อยา,จำนวนขอ,จำนวนจ่าย,Onhand คลังขอ,Onhand คลังจ่าย,หน่วย${props.notAllowedAdd ? "": ","}`}
            id="CardDrugTransferRequestUX-Table-5"
            keys={`no,code,name,request_quantity,storekey,onhand_requester,onhand_provider,stock_unit_name${props.notAllowedAdd ? "": ",remove"}`}
            minRows="10"
            showPagination={false}
            style={{height: "300px"}}
            widths={props.notAllowedAdd ? "" : ",,,,,,,,75"}>
          </Table>
        </div>
        <div
          id="CardDrugTransferRequestUX-div-4"
          style={{display: "flex",  marginTop: "10px"}}>
          
          <Button
            color="blue"
            id="CardDrugTransferRequestUX-Button-61"
            onClick={props.onNew}
            size="tiny"
            style={{display: !props.requested?.id || props.notAllowedAdd ? "none":""}}>
            {props.languageUX === "en" ? "NEW" : "ใหม่"}
          </Button>
          <Button
            color="blue"
            id="CardDrugTransferRequestUX-Button-62"
            onClick={props.onLog}
            size="tiny"
            style={{display: props.requested?.id ? "":"none"}}>
            {props.languageUX === "en" ? "LOG" : "บันทึก"}
          </Button>
          <div
            id="CardDrugTransferRequestUX-div-60"
            style={{flex:"1"}}>
            
          </div>
          <Button
            color="green"
            id="CardDrugTransferRequestUX-Button-6"
            onClick={props.onRequest}
            size="tiny"
            style={{display: props.requested?.id ? "none":""}}>
            {props.languageUX === "en" ? "REQUEST" : "REQUEST"}
          </Button>
          <Button
            color="green"
            id="CardDrugTransferRequestUX-Button-58"
            onClick={props.onEdit}
            size="tiny"
            style={{display: props.requested?.id  && !props.canceled ? "":"none"}}>
            {props.languageUX === "en" ? "EDIT" : "แก้ไข"}
          </Button>
          <Button
            color="red"
            id="CardDrugTransferRequestUX-Button-59"
            onClick={props.onCancel}
            size="tiny"
            style={{display: props.requested?.id  && !props.canceled ? "":"none"}}>
            {props.languageUX === "en" ? "CANCEL" : "ยกเลิก"}
          </Button>
        </div>
      </div>
    )
}


export default CardDrugTransferRequestUX

export const screenPropsDefault = {"drugSearch":"[Drug Search Box]","language":"EN"}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-3"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",  marginTop: \"10px\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 5,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props.drugTransferRequestlist"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.drugRowProps"
        },
        "headers": {
          "type": "code",
          "value": "`ลำดับ,รหัสยา,ชื่อยา,จำนวนขอ,จำนวนจ่าย,Onhand คลังขอ,Onhand คลังจ่าย,หน่วย${props.notAllowedAdd ? \"\": \",\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Table-5"
        },
        "keys": {
          "type": "code",
          "value": "`no,code,name,request_quantity,storekey,onhand_requester,onhand_provider,stock_unit_name${props.notAllowedAdd ? \"\": \",remove\"}`"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\"}"
        },
        "widths": {
          "type": "code",
          "value": "props.notAllowedAdd ? \"\" : \",,,,,,,,75\""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "REQUEST",
          "valueEN": "REQUEST"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Button-6"
        },
        "onClick": {
          "type": "code",
          "value": "props.onRequest"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{display: props.requested?.id ? \"none\":\"\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไข",
          "valueEN": "EDIT"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Button-58"
        },
        "onClick": {
          "type": "code",
          "value": "props.onEdit"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{display: props.requested?.id  && !props.canceled ? \"\":\"none\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Button-59"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancel"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{display: props.requested?.id  && !props.canceled ? \"\":\"none\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ใหม่",
          "valueEN": "NEW"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Button-61"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNew"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{display: !props.requested?.id || props.notAllowedAdd ? \"none\":\"\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "LOG"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Button-62"
        },
        "onClick": {
          "type": "code",
          "value": "props.onLog"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{display: props.requested?.id ? \"\":\"none\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-80"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.5rem 0\",  display: props.showStatus ? \"\" : \"none\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "code",
          "value": "props.code"
        },
        "className": {
          "type": "value",
          "value": "ui label violet ribbon"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-99"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showStatus ? \"\" : \"none\"}"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "ขอยาจากห้องยาอื่นๆ",
          "valueEN": "Request medicine from other pharmacies"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Label",
      "parent": 98,
      "props": {
        "children": {
          "type": "code",
          "value": "props.status"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "color": {
          "type": "code",
          "value": "props.status ? \"red\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Label-101"
        },
        "name": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: props.showStatus ? \"\" : \"none\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{cursor: \"pointer\", margin: \"3px -5px 0 15px\", display: props.closeIcon ? \"\" : \"none\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Icon",
      "parent": 102,
      "props": {
        "className": {
          "type": "value",
          "value": "red large"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Icon-103"
        },
        "name": {
          "type": "code",
          "value": "\"close\""
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-104"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormGroup",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormGroup-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-107"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 109,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-109"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "FormField",
      "parent": 105,
      "props": {
        "className": {
          "type": "code",
          "value": "props.notAllowedAdd ? \"hidden\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-110"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 105,
      "props": {
        "className": {
          "type": "code",
          "value": "props.notAllowedAdd ? \"hidden\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 105,
      "props": {
        "className": {
          "type": "code",
          "value": "props.notAllowedAdd ? \"hidden\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 105,
      "props": {
        "className": {
          "type": "code",
          "value": "props.notAllowedAdd ? \"hidden\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 105,
      "props": {
        "className": {
          "type": "code",
          "value": "props.notAllowedAdd ? \"hidden\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "div",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานที่ขอ",
          "valueEN": "Request department by"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-116"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "Label",
      "parent": 107,
      "props": {
        "children": {
          "type": "code",
          "value": "props.requesterName || \"\\u00a0-\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Label-117"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานจ่าย",
          "valueEN": "Dispensing department by"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 119,
      "name": "Dropdown",
      "parent": 109,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Dropdown-119"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue(\"selectedDivisionPharma\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionPharmaOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivisionPharma"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกยา",
          "valueEN": "Select drug"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-120"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "props.drugSearch"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวน",
          "valueEN": "Quantity"
        },
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "Input",
      "parent": 113,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Input-123"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue(\"selectedDrugDose\")"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.selectedDrugDose || \"\""
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "Button",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม",
          "valueEN": "ADD"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Button-124"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddDrug"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "FormGroup",
      "parent": 104,
      "props": {
        "className": {
          "type": "code",
          "value": "props.requested?.id ? \"\":\"hidden\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormGroup-125"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "FormField",
      "parent": 125,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-126"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "FormField",
      "parent": 125,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-127"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 128,
      "name": "FormField",
      "parent": 125,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-128"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 129,
      "name": "FormField",
      "parent": 125,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-129"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ขอ",
          "valueEN": "Requester"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{width: \"50px\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "Input",
      "parent": 127,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Input-133"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.requested?.name || \"\""
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 128,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-134"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "Input",
      "parent": 129,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Input-135"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.requestedDate || \"\""
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormGroup",
      "parent": 104,
      "props": {
        "className": {
          "type": "code",
          "value": "!props.canceled  ? \"hidden\":\"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormGroup-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "FormField",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-139"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "FormField",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-140"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormField",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 138,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ยกเลิก",
          "valueEN": "Canceller"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-145"
        },
        "style": {
          "type": "code",
          "value": "{width: \"50px\"}"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "time"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-146"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 149,
      "name": "Input",
      "parent": 142,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Input-149"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.canceledDate || \"\""
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 150,
      "name": "Input",
      "parent": 140,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Input-150"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.canceled?.name || \"\""
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 151,
      "name": "FormField",
      "parent": 105,
      "props": {
        "className": {
          "type": "code",
          "value": "props.notAllowedAdd ? \"hidden\" : \"\""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-FormField-151"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 152,
      "name": "Button",
      "parent": 151,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-Button-152"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 105,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestUX-div-153"
        },
        "style": {
          "type": "code",
          "value": "{\"margin\":\"0px 1rem 0px 0.25rem\",\"width\":\"10px\",\"height\":\"10px\",\"borderRadius\":\"50%\",\"backgroundColor\":\"#b3b0b0\", display: props.notAllowedAdd ? \"none\" : \"\"}"
        }
      },
      "seq": 110,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugTransferRequestUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "drugSearch": "[Drug Search Box]",
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
